<template>
    <transition name="modal">
        <div class="modal__mask modalpassword" v-if="abrirModal > 0">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">
                        <div class="inner__modal_password">
                            <div class="row">
                                <div class="label__field">
                                    <label class="label" for="email">Senha atual*</label>
                                    <input class="field" type="password"  v-model="cadastro.senhaAtual" id="senhaAtual">
                                </div>
                            </div>

                            <div class="row">
                                <div class="label__field">
                                    <label class="label" for="email">Senha nova*</label>
                                    <input class="field"  :type="senhaVisivel ? 'text' : 'password'"  v-model="cadastro.novaSenha" id="senhaNova">
                                                                        <button 
                                        type="button"
                                        class="toggle-password-btn" 
                                        :class="{ 'senha-visivel': senhaVisivel }"
                                        @click="toggleSenhaVisibilidade"
                                        tabindex="-1">
                                    </button>
                                </div>
                            </div>

                            <div class="row">
                                <div class="label__field">
                                    <label class="label" for="email">Confirmação nova senha*</label>
                                    <input class="field" :type="senhaVisivel ? 'text' : 'password'" v-model="cadastro.confirmacaoNovaSenha" id="confirmacaoNovaSenha">
                                    <button 
                                        type="button"
                                        class="toggle-password-btn" 
                                        :class="{ 'senha-visivel': senhaVisivel }"
                                        @click="toggleSenhaVisibilidade"
                                        tabindex="-1">
                                    </button>
                                </div>
                            </div>
                                    
                            <div class="buttonsAcoes">  
                                <div class="buttonsAcoes_sub">
                                    <button class="btnBlue" @click="confirmar">Alterar</button>
                                    <button class="btnDefault" @click="closeModal">Voltar</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import SHA256 from 'crypto-js/sha256';

export default {
    computed: {
        ...mapGetters({
            user: 'auth/user',
            abrirModal: 'GET_ABRIR_ALTERAR_SENHA'
        }),
    },
    data() {
        return { 
            senhaVisivel: false,
            cadastro: {
                senhaAtual: '',
                novaSenha: '',
                confirmacaoNovaSenha: '',
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_ABRIR_ALTERAR_SENHA", 0);
            this.cadastro = {
                senhaAtual: '',
                novaSenha: '',
                confirmacaoNovaSenha: '',
            };
            this.erroConfirmar = false;
        },
        toggleSenhaVisibilidade() {
            this.senhaVisivel = !this.senhaVisivel;
        },
        validarForm(){
            if(!this.cadastro.senhaAtual){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Senha atual não foi informada`,
                });
                return false;
            }

            if(!this.cadastro.novaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Nova senha não foi informada`,
                });
                return false;
            }

            if(!this.cadastro.confirmacaoNovaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Confirmação da nova senha não foi informada`,
                });
                return false;
            }

            if(this.cadastro.novaSenha != this.cadastro.confirmacaoNovaSenha){
                this.$swal({
                    icon: 'error',
                    title: 'Falha ao atualizar senha',
                    text: `Nova senha é diferente da confirmação de nova senha`,
                });
                return false;
            }

            return true;
        },
        async confirmar(){
            if(!this.validarForm()){
                this.erroConfirmar = true;
            }else{
                 
                var obj = { 
                    SenhaAtual: this.cadastro.senhaAtual ? SHA256(this.cadastro.senhaAtual).toString() : '', 
                    NovaSenha: this.cadastro.novaSenha ? SHA256(this.cadastro.novaSenha).toString() : '', 
                    ConfirmarNovaSenha: this.cadastro.confirmacaoNovaSenha ? SHA256(this.cadastro.confirmacaoNovaSenha).toString() : '' 
                };

                await api.post('/cliente/alterar-senha', obj).then((retorno) => {
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: 'Alterar senha',
                                text: 'Alteração realizada com sucesso',
                                });
                                this.$store.commit("SET_ABRIR_ALTERAR_SENHA", 0);
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Alteração de senha',
                            text: `${error.response.data.data[0]}`,
                        });
                        
                    });


            }
        }
    },
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_password{

    margin-top: 40px !important;
    width: 100% !important;
    align-content: center;

    h2{
       margin-bottom: 20px !important;
    }

    .row{
      margin-bottom: 5px !important;
      padding: 5px 40px !important;
      margin-left: 0px !important;
    }

    .buttonsAcoes{
        width: 100%;
        display: block;
        margin-top: 0px;
        margin-bottom: 10px;

        .buttonsAcoes_sub{
            padding: 10px 40px;
            

            .btnBlue, .btnDefault{
                margin-bottom: 5px;
                width: 100%;
            }
        }

    }

    .field {
        padding: 10px 0px !important
    }

    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    }


    img{
        margin-left: 42%;
    }

}


.modalpassword .modal__wrapper .modal__container.reset {
        width: 400px;
        height: 400px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
